export default __webpack_public_path__ + "static/media/MATIC.a3d0c752.svg";